/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mImgEmpty.vue?vue&type=template&id=02222b64&scoped=true"
import script from "./mImgEmpty.vue?vue&type=script&lang=js"
export * from "./mImgEmpty.vue?vue&type=script&lang=js"
import style0 from "./mImgEmpty.vue?vue&type=style&index=0&id=02222b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02222b64",
  null
  
)

export default component.exports